jQuery( document ).ready(function($) {
     $('.list-menu__item span').click(function(){
       $(this).closest('.list-menu__item').toggleClass('active_item');
    })

  $('.annouce-slider').flickity({
    contain: true,
    pageDots: false,
    prevNextButtons: false,
    autoPlay: 5000 ,
    wrapAround: true
  });
  var $backToTop = $('.back-to-top');
  $backToTop.hide();

  $(window).on('scroll', function() {
    if ($(this).scrollTop() > 100) {
      $backToTop.fadeIn();
    } else {
      $backToTop.fadeOut();
    }
  });

  $backToTop.on('click', function(e) {
    $('html, body').animate({scrollTop: 0}, 500);
  });

  $('.product-grid-container').addClass('grid-view-section');
    $('.grid-view').click(function() {
        $(this).addClass('active');
        $('.list-view').removeClass('active');
        $('.product-grid-container').removeClass('list-view-section1').addClass('grid-view-section');
        $('#product-grid').removeClass('grid--4-col-desktop grid--2-col-tablet-down').addClass('grid--2-col-desktop grid--1-col-tablet-down');
    });

    $('.list-view').click(function() {
        $(this).addClass('active');
        $('.grid-view').removeClass('active');
        $('.product-grid-container').removeClass('grid-view-section1').addClass('list-view-section1');
        $('#product-grid').removeClass('grid--2-col-desktop grid--1-col-tablet-down').addClass('grid--4-col-desktop grid--2-col-tablet-down');
    });
  });

document.addEventListener('DOMContentLoaded', function () {
  const stickyForm = document.querySelector('product-sticky-form');
  const footer = document.querySelector('footer');
  if (stickyForm && footer) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            stickyForm.style.display = 'none';
          } else {
            stickyForm.style.display = '';
          }
        });
      },
      { root: null, threshold: 0 }
    );
    observer.observe(footer);
  }
});

/* Benefit-Badges Overlay (von Claude) - START
   Zeigt animierte Benefit-Badges in den Ecken des ERSTEN Produktbilds,
   auf allen Produktseiten (Desktop + Mobile). Kein Bild wird veraendert.
   Blenden nach HB_HIDE_AFTER ms (30 Sek) wieder aus.
   Texte anpassen: siehe HB_BENEFITS. Ausblendzeit: HB_HIDE_AFTER.
   Entfernen: diesen Block (START ... ENDE) loeschen. */
(function () {
  // h = Einflug-Richtung (left/right). Die genaue Ecke/Hoehe kommt aus dem
  // CSS je Reihenfolge: 1=oben-links, 2=oben-rechts, 3=unten-links, 4=unten-rechts
  // (auf dem Handy versetzte Hoehen, siehe @media-Block im HB_CSS).
  var HB_BENEFITS = [
    { text: 'Premium Baumwolle', h: 'left'  },
    { text: 'Auffällige Prints',      h: 'right' },
    { text: 'Europäische Qualität',   h: 'left'  },
    { text: 'Angenehmes Tragegefühl', h: 'right' }
  ];

  // Nach so vielen Millisekunden blenden die Badges wieder aus (30 Sek).
  var HB_HIDE_AFTER = 30000;

  // Abweichende Texte fuer Produkte mit bestimmtem Tag (Tag in Kleinbuchstaben).
  // Zahl = Position des Badges (1=oben-links, 2=oben-rechts, 3=unten-links, 4=unten-rechts).
  var HB_TAG_OVERRIDES = {
    'gestickt': { 2: 'Hochwertig gestickt' }
  };

  var HB_CSS =
    '.hb-benefits{position:absolute;inset:0;z-index:4;pointer-events:none;overflow:visible;}' +
    '.hb-benefit{position:absolute;opacity:0;transition:opacity .9s ease,transform 1s cubic-bezier(.22,1,.36,1);will-change:transform,opacity;}' +
    '.hb-benefit.hb-left{transform:translateX(-20px) scale(.9);}' +
    '.hb-benefit.hb-right{transform:translateX(20px) scale(.9);}' +
    '.hb-benefit.hb-in{opacity:1;transform:none;}' +
    '.hb-benefit.hb-in.hb-out{opacity:0;}' +
    '.hb-b1{top:4%;left:2%;transition-delay:.20s;}' +
    '.hb-b2{top:4%;right:2%;transition-delay:.55s;}' +
    '.hb-b3{bottom:5%;left:2%;transition-delay:.90s;}' +
    '.hb-b4{bottom:5%;right:2%;transition-delay:1.25s;}' +
    '.hb-pill{display:inline-block;background:rgba(255,255,255,.96);color:#111;font-weight:700;font-size:14px;line-height:1.1;letter-spacing:.2px;padding:10px 16px;border-radius:999px;box-shadow:0 8px 22px rgba(0,0,0,.24),0 1px 2px rgba(0,0,0,.14);white-space:nowrap;-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px);}' +
    '@media screen and (max-width:749px){' +
    '.hb-pill{font-size:11px;padding:6px 10px;box-shadow:0 5px 16px rgba(0,0,0,.26);}' +
    '.hb-b1{top:3%;}.hb-b2{top:15%;}.hb-b3{bottom:16%;}.hb-b4{bottom:4%;}' +
    '}' +
    '@media (prefers-reduced-motion: reduce){.hb-benefit{transition-duration:.01s;}}';

  function hbInjectStyle() {
    if (document.getElementById('hb-benefits-style')) return;
    var s = document.createElement('style');
    s.id = 'hb-benefits-style';
    s.textContent = HB_CSS;
    document.head.appendChild(s);
  }

  function hbBuildOverlay() {
    var wrap = document.createElement('div');
    wrap.className = 'hb-benefits';
    HB_BENEFITS.forEach(function (b, i) {
      var el = document.createElement('div');
      var isLeft = b.h !== 'right';
      el.className = 'hb-benefit hb-b' + (i + 1) + (isLeft ? ' hb-left' : ' hb-right');
      el.innerHTML = `<span class='hb-pill'>` + b.text + `</span>`;
      wrap.appendChild(el);
    });
    return wrap;
  }

  var hbTagsPromise = null;
  function hbApplyTagOverrides(overlay) {
    var path = location.pathname.replace(/\/$/, '');
    if (path.indexOf('/products/') === -1) return;
    if (!hbTagsPromise) {
      hbTagsPromise = fetch(path + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { return (p && p.tags) || []; })
        .catch(function () { return []; });
    }
    hbTagsPromise.then(function (tags) {
      tags.forEach(function (tag) {
        var o = HB_TAG_OVERRIDES[String(tag).trim().toLowerCase()];
        if (!o) return;
        Object.keys(o).forEach(function (pos) {
          var pill = overlay.querySelector('.hb-b' + pos + ' .hb-pill');
          if (pill) pill.textContent = o[pos];
        });
      });
    });
  }

  function hbInject() {
    // Nur auf Produktseiten (body-Klasse enthaelt den Template-Namen 'product')
    if (!document.body || !/(^|\s)product(\s|$)/.test(document.body.className)) return;
    var lists = document.querySelectorAll('.product__media-list');
    if (!lists.length) return;
    hbInjectStyle();
    lists.forEach(function (list) {
      var firstItem = list.querySelector('.product__media-item');
      if (!firstItem) return;
      var target = firstItem.querySelector('.product__media') || firstItem;
      if (target.querySelector('.hb-benefits')) return;
      var cs = window.getComputedStyle(target);
      if (cs.position === 'static') target.style.position = 'relative';
      var overlay = hbBuildOverlay();
      target.appendChild(overlay);
      hbApplyTagOverrides(overlay);
      var shown = false;
      var play = function () {
        if (shown) return;
        shown = true;
        var badges = overlay.querySelectorAll('.hb-benefit');
        for (var i = 0; i < badges.length; i++) badges[i].classList.add('hb-in');
        // Nach HB_HIDE_AFTER ms wieder ausblenden
        setTimeout(function () {
          for (var j = 0; j < badges.length; j++) badges[j].classList.add('hb-out');
        }, HB_HIDE_AFTER);
      };
      requestAnimationFrame(function () { requestAnimationFrame(play); });
      setTimeout(play, 250);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hbInject);
  } else {
    hbInject();
  }
  document.addEventListener('shopify:section:load', hbInject);
})();
/* Benefit-Badges Overlay (von Claude) - ENDE */

/* Sticky-Add-to-Cart Fix (von Claude) - START
   Manche Produkte haben ZWEI Sticky-Warenkorb-Leisten: die Theme-eigene
   (product-sticky-form, liegt hinten) und die Vitals-App-Leiste
   (#bundle-sticky_add_to_cart, liegt vorne, mit Varianten-Auswahl).
   Nur wenn die Vitals-Leiste SICHTBAR ist, blenden wir die hintere Theme-Leiste
   aus -> es bleibt genau eine (die vordere). Produkte ohne Vitals behalten ihre
   Theme-Leiste. Entfernen: diesen Block (START ... ENDE) loeschen. */
(function () {
  var css =
    '.hb-has-vitals-sticky product-sticky-form,' +
    '.hb-has-vitals-sticky .product-sticky-form{display:none !important;}';
  var s = document.createElement('style');
  s.id = 'hb-sticky-fix';
  s.textContent = css;
  (document.head || document.documentElement).appendChild(s);

  // Ist die Vitals-Sticky WIRKLICH sichtbar gerendert? (Element kann existieren,
  // aber display:none / hoehe 0 sein -> dann NICHT ausblenden, sonst verlieren
  // Produkte ohne Bundle ihre Theme-Leiste.)
  function hbVitalsVisible() {
    var el = document.getElementById('bundle-sticky_add_to_cart') ||
             document.querySelector('.Vtl-StickyAddToCart');
    if (!el) return false;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return false;
    return el.getBoundingClientRect().height > 10;
  }

  function hbApplyStickyFix() {
    document.documentElement.classList.toggle('hb-has-vitals-sticky', hbVitalsVisible());
  }

  hbApplyStickyFix();
  document.addEventListener('DOMContentLoaded', hbApplyStickyFix);
  window.addEventListener('load', hbApplyStickyFix);
  window.addEventListener('scroll', hbApplyStickyFix, { passive: true });
  window.addEventListener('resize', hbApplyStickyFix, { passive: true });
  // Vitals laedt/aktiviert die Leiste verzoegert -> regelmaessig nachpruefen.
  setInterval(hbApplyStickyFix, 500);
})();
/* Sticky-Add-to-Cart Fix (von Claude) - ENDE */

/* Geschenk-Produkte ausblenden (von Claude) - START
   Die Flaschen (Handles: edelstahl-...-bar-code) sind nur ueber die Set-Seite
   (/pages/geschenk-2) gedacht. Hier werden sie aus Produktgittern, Suche und der
   Kollektionsuebersicht (/collections) ausgeblendet. NICHT im Warenkorb und NICHT
   auf der Set-Seite. Neue Geschenk-Produkte folgen dem Muster edelstahl-...-bar-code.
   Entfernen: diesen Block (START ... ENDE) loeschen. */
(function () {
  var GIFT_COLL = ['trinkflasche', 'trinkflasche-mit-babusdeckel', 'thermoflasche', 'thermobecher'];
  // Zusaetzlich versteckte Kollektionen: nur per Direktlink/Collection-Bar erreichbar,
  // NICHT in der /collections-Uebersicht (z.B. Sale-Kollektionen). Handles hier ergaenzen.
  var HIDE_COLL = ['25-sale', '30', '35-sale'];
  var CARD_SEL = '.grid__item, .card-wrapper, .product-card-wrapper, .collection-list__item, .predictive-search__list-item';
  var SKIP_SEL = '.cart-items, cart-drawer, .cart-drawer, cart-notification, .cart-notification, .template-cart, .setb, [data-setb]';

  function isGiftProduct(href) {
    if (!href) return false;
    var i = href.indexOf('/products/');
    if (i === -1) return false;
    var rest = href.slice(i + 10);
    return rest.indexOf('edelstahl-') === 0 && rest.indexOf('bar-code') !== -1;
  }

  function isGiftCollection(href) {
    if (!href) return false;
    var i = href.indexOf('/collections/');
    if (i === -1) return false;
    var rest = href.slice(i + 13);
    var handle = rest.split('/')[0].split('?')[0].split('#')[0];
    return GIFT_COLL.indexOf(handle) !== -1 || HIDE_COLL.indexOf(handle) !== -1;
  }

  function hide(a) {
    if (!a || a.closest(SKIP_SEL)) return;
    var card = a.closest(CARD_SEL);
    if (card && !card.closest(SKIP_SEL)) card.style.display = 'none';
  }

  function scan() {
    var onCollList = location.pathname === '/collections' || location.pathname === '/collections/';
    var links = document.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href') || '';
      if (isGiftProduct(href)) { hide(links[i]); continue; }
      if (onCollList && isGiftCollection(href)) hide(links[i]);
    }
  }

  var raf;
  function schedule() {
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = null; scan(); });
  }

  scan();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  window.addEventListener('load', scan);
  document.addEventListener('shopify:section:load', scan);
  try {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { schedule(); break; }
      }
    });
    if (document.body) mo.observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
})();
/* Geschenk-Produkte ausblenden (von Claude) - ENDE */

/* Bundle-Gift-Widget umbauen (von Claude) - START
   Entfernt die Fortschritts-Schritte, verschiebt die schwarze CTA-Box in die
   Angebots-Box unter den Gratis-Geschenk-Badge, und haelt den Button IMMER
   aktiv (Link zur Set-Seite - man waehlt die Shirts erst dort). */
(function () {
  var css =
    '.bundle-gift__progress{display:none !important;}' +
    '.bundle-gift .bundle-gift__offer{border-radius:1.2rem !important;}' +
    '.bundle-gift .bundle-gift__gift{border-radius:.8rem !important;margin-top:1.4rem !important;}' +
    '.bundle-gift .bundle-gift__link[aria-disabled="true"]{pointer-events:auto !important;opacity:1 !important;cursor:pointer !important;}';
  var s = document.createElement('style');
  s.id = 'hb-bundle-restructure';
  s.textContent = css;
  (document.head || document.documentElement).appendChild(s);

  function restructure() {
    document.querySelectorAll('.bundle-gift').forEach(function (bg) {
      var offer = bg.querySelector('.bundle-gift__offer');
      var gift = bg.querySelector('.bundle-gift__gift');
      var progress = bg.querySelector('.bundle-gift__progress');
      if (progress) progress.remove();
      if (offer && gift && !bg.dataset.hbRestructured) { offer.appendChild(gift); bg.dataset.hbRestructured = '1'; }
      var link = bg.querySelector('.bundle-gift__link');
      if (link) { link.setAttribute('aria-disabled', 'false'); link.tabIndex = 0; }
    });
  }

  restructure();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restructure);
  document.addEventListener('shopify:section:load', restructure);
  try {
    var mo = new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) { if (m[i].addedNodes && m[i].addedNodes.length) { restructure(); break; } }
    });
    if (document.body) mo.observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
})();
/* Bundle-Gift-Widget umbauen (von Claude) - ENDE */

/* Zahlungs-Icons: Produktseite in EINE Reihe + gleiche Icons im Warenkorb (von Claude) - START
   1) Produktseite (.shop__payment .list-payment): erzwingt EINE Reihe, gleiche Groesse.
   2) Warenkorb-Seite (.sub__total_cart) UND Warenkorb-Schublade (cart-drawer .drawer__footer):
      baut aus den Fusszeilen-Icons (immer vorhanden) eine identische Icon-Reihe (.hb-payrow)
      unter dem Kasse-Button. Entfernen: diesen Block (START ... ENDE) loeschen. */
(function () {
  var css =
    '.hb-payrow{display:flex;flex-wrap:nowrap;align-items:center;justify-content:center;gap:8px;margin:14px 0 4px;overflow-x:auto;-webkit-overflow-scrolling:touch;scrollbar-width:none;}' +
    '.hb-payrow::-webkit-scrollbar{display:none;}' +
    '.hb-payrow .hb-pay-icon{width:38px;height:24px;flex:0 0 auto;border-radius:4px;}' +
    '.shop__payment .list-payment{flex-wrap:nowrap !important;overflow-x:auto;justify-content:center;scrollbar-width:none;}' +
    '.shop__payment .list-payment::-webkit-scrollbar{display:none;}' +
    '.shop__payment .list-payment .list-payment__item{flex:0 0 auto;margin:0 4px;}' +
    '.shop__payment .list-payment svg{width:38px !important;height:24px !important;}' +
    '@media (max-width:749px){' +
      '.hb-payrow{gap:5px;}' +
      '.hb-payrow .hb-pay-icon{width:34px;height:21px;}' +
      '.shop__payment .list-payment{gap:3px !important;}' +
      '.shop__payment .list-payment .list-payment__item{padding:0 !important;margin:0 !important;}' +
      '.shop__payment .list-payment svg{width:34px !important;height:21px !important;}' +
    '}';
  var s = document.createElement('style');
  s.id = 'hb-payrow-style';
  s.textContent = css;
  (document.head || document.documentElement).appendChild(s);

  function buildRow() {
    var src = document.querySelectorAll('.footer__payment .list-payment svg');
    if (!src.length) return null;
    var row = document.createElement('div');
    row.className = 'hb-payrow';
    src.forEach(function (svg) {
      var c = svg.cloneNode(true);
      c.removeAttribute('id');
      c.setAttribute('class', 'hb-pay-icon');
      row.appendChild(c);
    });
    return row.children.length ? row : null;
  }

  function place() {
    var summary = document.querySelector('cart-items .sub__total_cart');
    if (summary && !summary.querySelector('.hb-payrow')) { var r = buildRow(); if (r) summary.appendChild(r); }
    var df = document.querySelector('cart-drawer .drawer__footer');
    if (df && !df.querySelector('.hb-payrow')) { var r2 = buildRow(); if (r2) df.appendChild(r2); }
  }

  place();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place);
  window.addEventListener('load', place);
  document.addEventListener('shopify:section:load', place);
  try {
    var mo = new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) { if (m[i].addedNodes && m[i].addedNodes.length) { place(); break; } }
    });
    if (document.body) mo.observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
})();
/* Zahlungs-Icons: Produktseite in EINE Reihe + gleiche Icons im Warenkorb (von Claude) - ENDE */

/* Angepinnter Sale-Streifen oben (von Claude) - START
   Schmaler, sticky Streifen direkt unter der Ankuendigung, site-weit, mit Button
   zur Sale-Kollektion. Bleibt beim Scrollen oben sichtbar. Text/Link: HB_SALE unten.
   Entfernen: diesen Block (START ... ENDE) loeschen. */
(function () {
  var HB_SALE = { text: '<span style="font-size:1.3em;vertical-align:-0.1em;filter:drop-shadow(0 0 1px #fff) drop-shadow(0 0 3px #fff)">🖤</span> Black Month – bis zu 50%', btn: 'Zum Sale', url: '/collections/black-month' };
  var css =
    '.hb-cpn{position:sticky;top:0;z-index:30;display:flex;align-items:center;justify-content:center;gap:12px;flex-wrap:wrap;background:#000;color:#fff;padding:8px 14px;font-family:inherit;font-size:13px;font-weight:700;line-height:1.2;text-align:center;}' +
    '.hb-cpn__txt{letter-spacing:.5px;}' +
    '.hb-cpn__btn{display:inline-flex;align-items:center;border:none;border-radius:999px;background:#fff;color:#000;font:inherit;font-weight:800;padding:5px 16px;cursor:pointer;text-decoration:none;transition:opacity .2s,transform .1s;white-space:nowrap;}' +
    '.hb-cpn__btn:hover{opacity:.9;}' +
    '.hb-cpn__btn:active{transform:scale(.97);}' +
    '@media (max-width:600px){.hb-cpn{gap:9px;font-size:12px;padding:7px 10px;}.hb-cpn__btn{padding:5px 13px;}}';
  var s = document.createElement('style');
  s.id = 'hb-cpn-style';
  s.textContent = css;
  (document.head || document.documentElement).appendChild(s);

  function build() {
    var bar = document.createElement('div');
    bar.className = 'hb-cpn';
    bar.setAttribute('data-hb-cpn', '');
    bar.innerHTML = '<span class="hb-cpn__txt">' + HB_SALE.text + '</span><a class="hb-cpn__btn" href="' + HB_SALE.url + '">' + HB_SALE.btn + '</a>';
    return bar;
  }

  function place() {
    if (document.querySelector('[data-hb-cpn]')) return;
    var ann = document.querySelector('.announcement-bar-section');
    if (ann) { ann.insertAdjacentElement('afterend', build()); }
  }

  place();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place);
  document.addEventListener('shopify:section:load', place);
  try {
    var mo = new MutationObserver(function () { if (!document.querySelector('[data-hb-cpn]')) place(); });
    if (document.body) mo.observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
})();
/* Angepinnter Sale-Streifen oben (von Claude) - ENDE */

/* Warenkorb: Vergleichspreise + "Du sparst" (von Claude) - START
   Zeigt je Zeile den durchgestrichenen Vergleichspreis (Zeilensumme) und unten
   eine "Du sparst"-Zeile (Vergleichspreise minus zu zahlender Betrag, inkl. Rabatte
   wie die Gratis-Flasche). Vergleichspreis kommt aus /products/<handle>.js (gecacht),
   da /cart.js ihn nicht liefert. Gilt fuer Warenkorb-Seite UND -Schublade.
   Entfernen: diesen Block (START ... ENDE) loeschen. */
(function () {
  var css =
    '.hb-ca{display:inline-block;margin-right:7px;color:rgba(var(--color-foreground),.45);text-decoration:line-through;font-weight:400;}' +
    '.hb-savings{display:flex;align-items:center;justify-content:space-between;gap:1rem;margin:.6rem 0 0;color:#22a06b;font-weight:700;}';
  var st = document.createElement('style');
  st.id = 'hb-cartsave-style';
  st.textContent = css;
  (document.head || document.documentElement).appendChild(st);

  var CACHE = {};
  function money(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  function handleOf(url) { if (!url) return null; var m = url.split('/products/')[1]; return m ? m.split('?')[0].split('#')[0] : null; }

  function compute() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      if (!cart || !cart.items.length) return null;
      var handles = [];
      cart.items.forEach(function (i) { var h = handleOf(i.url); if (h && handles.indexOf(h) === -1 && !CACHE[h]) handles.push(h); });
      return Promise.all(handles.map(function (h) {
        return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) { if (p) CACHE[h] = p; }).catch(function () {});
      })).then(function () {
        var compareTotal = 0, byVariant = {};
        cart.items.forEach(function (it) {
          var p = CACHE[handleOf(it.url)];
          var ca = null;
          if (p && p.variants) { var v = p.variants.filter(function (x) { return x.id === it.variant_id; })[0]; if (v && v.compare_at_price && v.compare_at_price > it.price) ca = v.compare_at_price; }
          compareTotal += (ca || it.price) * it.quantity;
          if (ca) byVariant[it.variant_id] = ca;
        });
        return { byVariant: byVariant, savings: compareTotal - cart.total_price };
      });
    }).catch(function () { return null; });
  }

  function render(data) {
    if (!data) return;
    // 1) Vergleichspreis je Zeile (Zeilensumme)
    document.querySelectorAll('.cart-item').forEach(function (row) {
      if (row.dataset.hbCa) return;
      var link = row.querySelector('a[href*="variant="]');
      if (!link) return;
      var vid = parseInt((link.getAttribute('href').split('variant=')[1] || '').split('&')[0], 10);
      var ca = data.byVariant[vid];
      if (!ca) { row.dataset.hbCa = '1'; return; }
      var qi = row.querySelector('input.quantity__input, input[name="updates[]"]');
      var qty = qi ? (parseInt(qi.value, 10) || 1) : 1;
      var wraps = row.querySelectorAll('.cart-item__price-wrapper');
      if (wraps.length) {
        // Warenkorb-Seite: Vergleich = Zeilensumme neben dem Zeilenpreis (rechts)
        wraps.forEach(function (pw) {
          if (pw.querySelector('.hb-ca') || pw.querySelector('.cart-item__old-price')) return;
          var s1 = document.createElement('s'); s1.className = 'hb-ca'; s1.textContent = money(ca * qty);
          pw.insertBefore(s1, pw.firstChild);
        });
      } else {
        // Warenkorb-Schublade: Vergleich = Stueckpreis neben dem Preis unter dem Namen
        var details = row.querySelector('.cart-item__details');
        if (details && !details.querySelector('.cart-item__discounted-prices')) {
          var priceEl = null, kids = details.children;
          for (var k = 0; k < kids.length; k++) {
            if (kids[k].classList && kids[k].classList.contains('product-option') && /\d[.,]\d/.test(kids[k].textContent)) { priceEl = kids[k]; break; }
          }
          if (priceEl && !priceEl.querySelector('.hb-ca')) {
            var s2 = document.createElement('s'); s2.className = 'hb-ca'; s2.textContent = money(ca);
            priceEl.insertBefore(s2, priceEl.firstChild);
          }
        }
      }
      row.dataset.hbCa = '1';
    });
    // 2) "Du sparst"-Zeile bei den Summen
    if (data.savings > 0) {
      document.querySelectorAll('.totals').forEach(function (tot) {
        var host = tot.parentElement;
        if (!host || host.querySelector('.hb-savings')) return;
        var d = document.createElement('div'); d.className = 'hb-savings';
        d.innerHTML = '<span>Du sparst</span><span>' + money(data.savings) + '</span>';
        tot.insertAdjacentElement('afterend', d);
      });
    }
  }

  var t;
  function run() { clearTimeout(t); t = setTimeout(function () { compute().then(render); }, 250); }
  run();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', run);
  ['cart:updated', 'cart:refresh', 'cart:change'].forEach(function (ev) { document.addEventListener(ev, run); });
  try {
    var mo = new MutationObserver(function () {
      if (!document.querySelector('.cart-item')) return;
      if (document.querySelector('.cart-item:not([data-hb-ca])') || (document.querySelector('.totals') && !document.querySelector('.hb-savings'))) run();
    });
    if (document.body) mo.observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
})();
/* Warenkorb: Vergleichspreise + "Du sparst" (von Claude) - ENDE */

/* Slideshow-Ueberschrift: Schreibweise + Lesbarkeit (von Claude) - START
   1) Hebt text-transform:capitalize auf (Ueberschrift genau wie eingegeben, "zu" bleibt "zu").
   2) Gibt dem weissen Slideshow-Text einen sanften Schatten fuer bessere Lesbarkeit auf Bildern.
   Entfernen: diesen Block (START ... ENDE) loeschen. */
(function () {
  var s = document.createElement('style');
  s.id = 'hb-heading-caps';
  s.textContent =
    '.slideshow .banner__heading,.slideshow__text .banner__heading{text-transform:none !important;}' +
    '.slideshow__text{text-shadow:0 1px 3px rgba(0,0,0,.55),0 2px 14px rgba(0,0,0,.4);}' +
    '.slideshow__text .button,.slideshow__text a.button{text-shadow:none;}';
  (document.head || document.documentElement).appendChild(s);
})();
/* Slideshow-Ueberschrift: Schreibweise + Lesbarkeit (von Claude) - ENDE */

/* Farbbilder-Filter (von Claude) - START
   Zeigt auf Produktseiten nur die Bilder der gewaehlten Farbe. Zuordnung ueber den
   Alt-Text des Bildes: Alt-Text = Farbname genau wie in der Variante (z.B. "Black").
   Bilder mit leerem/anderem Alt-Text bleiben immer sichtbar. Produkte, bei denen kein
   Bild-Alt-Text einer Farbe entspricht, sind nicht betroffen.
   Entfernen: diesen Block (START ... ENDE) loeschen. */
(function () {
  var COLOR_LEGEND = /^(farbe|color|colour)$/i;
  var s = document.createElement('style');
  s.id = 'hb-colorfilter-style';
  s.textContent = '.hb-cf-hide{display:none !important;}';
  (document.head || document.documentElement).appendChild(s);

  function norm(v) { return (v || '').trim().toLowerCase(); }

  function colorFieldset(scope) {
    var sets = scope.querySelectorAll('fieldset');
    for (var i = 0; i < sets.length; i++) {
      var lg = sets[i].querySelector('legend');
      if (lg && COLOR_LEGEND.test(lg.textContent.trim())) return sets[i];
    }
    return null;
  }

  function apply(gallery) {
    var scope = gallery.closest('.shopify-section') || document;
    var fs = colorFieldset(scope);
    if (!fs) return;
    var radios = fs.querySelectorAll('input[type="radio"]');
    var colors = [], sel = '';
    for (var i = 0; i < radios.length; i++) {
      colors.push(norm(radios[i].value));
      if (radios[i].checked) sel = norm(radios[i].value);
    }
    if (!sel) return;

    var items = gallery.querySelectorAll('.product__media-item');
    var any = false, hidden = {};
    items.forEach(function (li) {
      var img = li.querySelector('img');
      var alt = norm(img ? img.getAttribute('alt') : '');
      if (colors.indexOf(alt) !== -1) any = true;
    });
    items.forEach(function (li) {
      var img = li.querySelector('img');
      var alt = norm(img ? img.getAttribute('alt') : '');
      var hide = any && colors.indexOf(alt) !== -1 && alt !== sel;
      li.classList.toggle('hb-cf-hide', hide);
      if (hide) hidden[li.getAttribute('data-media-id')] = true;
    });
    gallery.querySelectorAll('.thumbnail-list__item[data-target]').forEach(function (th) {
      th.classList.toggle('hb-cf-hide', !!hidden[th.getAttribute('data-target')]);
    });
    if (!any) return;

    var active = gallery.querySelector('.product__media-item.is-active');
    if (!active || active.classList.contains('hb-cf-hide')) {
      var first = gallery.querySelector('.product__media-item:not(.hb-cf-hide)');
      if (first && typeof gallery.setActiveMedia === 'function') {
        try { gallery.setActiveMedia(first.getAttribute('data-media-id'), false); } catch (e) {}
      }
    }
    gallery.querySelectorAll('slider-component').forEach(function (sl) {
      if (typeof sl.resetPages === 'function') { try { sl.resetPages(); } catch (e) {} }
    });
  }

  function applyAll() {
    document.querySelectorAll('media-gallery').forEach(apply);
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.type !== 'radio') return;
    var fs = t.closest('fieldset');
    var lg = fs && fs.querySelector('legend');
    if (!lg || !COLOR_LEGEND.test(lg.textContent.trim())) return;
    // nach der Theme-eigenen Variantenlogik ausfuehren
    setTimeout(applyAll, 60);
    setTimeout(applyAll, 400);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyAll);
  else applyAll();
  window.addEventListener('load', applyAll);
  document.addEventListener('shopify:section:load', applyAll);
})();
/* Farbbilder-Filter (von Claude) - ENDE */

/* Rote Vergleichspreise auf der Produktseite (von Claude) - START
   Faerbt auf Produktseiten den durchgestrichenen Vergleichspreis und die
   Prozent-Plakette (z.B. "-30%") rot. Farbe aendern: HB_RED unten.
   Entfernen: diesen Block (START ... ENDE) loeschen. */
(function () {
  var HB_RED = '#e3001b';
  var s = document.createElement('style');
  s.id = 'hb-redprice-style';
  s.textContent =
    '.product__info-container .price__sale s.price-item--regular{color:' + HB_RED + ' !important;text-decoration-color:' + HB_RED + ' !important;opacity:1 !important;}' +
    '.product__info-container .hb-savings-pct{background:' + HB_RED + ' !important;color:#fff !important;}';
  (document.head || document.documentElement).appendChild(s);
})();
/* Rote Vergleichspreise auf der Produktseite (von Claude) - ENDE */
